import { render } from "./ServicePay.vue?vue&type=template&id=49275861"
import script from "./ServicePay.vue?vue&type=script&lang=js"
export * from "./ServicePay.vue?vue&type=script&lang=js"

import "./ServicePay.vue?vue&type=style&index=0&id=49275861&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__